export default "__VITE_ASSET__UaiFDIkw__"